// extracted by mini-css-extract-plugin
export default {"comment-item":"CommentItem_comment-item__sP8Hs"};